import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../../components/button/MasterButton";

import { CloseOrCancelIcon } from "../../../assets/CloseOrCancel";

import "./userInfoModal.css";

import Skeleton from "../../../components/skeleton/Skeleton";

export type UserInfoModalProps = {
    index: number;
    onCloseClicked: () => void;
};

const UserInfoModal: React.FC<UserInfoModalProps> = ({ index, onCloseClicked }) => {

    return (
        <>  
            <div className="userinfo-modal-detail">
                <div className="title title-large">User Detail</div>

                <MasterButton
                    options={{
                        layoutType: ButtonLayoutType.Icon,
                        size: ButtonSize.Medium,
                        variation: ButtonVariation.Clean,
                        label: "",
                        icon: <CloseOrCancelIcon></CloseOrCancelIcon>,
                        className: "close-button",
                    }}
                    onClick={() => {
                        onCloseClicked();
                    }}
                />

                <div className="content"></div>
                
                <div className="empty-space"></div>

            </div>
        </>
    );
};

export default UserInfoModal;


